<template>
    <section class="chart-levels">
        <section class="emotion-level">
            <h5 class="chart-title">
                Emotion Level Count
            </h5>

            <UserReportStackChart
                class="chart"
                :labels="this.emotionLevelLabels"
                :data="emotionLevelCount"
                type="horizontalBar"
                height="200px"
                width="450px"
            />
        </section>

        <section class="stress-level">
            <h5 class="chart-title">
                Stress Level Count
            </h5>

            <UserReportStackChart
                class="chart"
                :labels="this.stressLevelLabels"
                :data="stressLevelCount"
                height="200px"
                width="300px"
            />
        </section>
    </section>
</template>

<script>
import UserReportStackChart from '@/components/user/UserReportStackChart.vue'

export default {
	props: {
		reportData: {
			required: true
		}
	},

	data () {
		return {
			emotionLevelLabels: [
				'Excitement', 'Happy', 'Zen', 'Pleasant',
				'Calm', 'Loading', 'Unpleasant', 'Confused',
				'Challenged', 'Hyped', 'Sad', 'Anxious'
			],

			stressLevelLabels: ['Low', 'Mild', 'Moderate', 'Severe']
		}
	},

	computed: {
		emotionLevelCount () {
			return this.emotionLevelLabels.reduce((result, item) => {
				const emotionCount = this.reportData.emotion_count[item]

				result.push(emotionCount)
				return result
			}, [])
		},

		stressLevelCount () {
			return this.stressLevelLabels.reduce((result, item) => {
				const emotionCount = this.reportData.stress_level_count[item]

				result.push(emotionCount)
				return result
			}, [])
		}
	},

	components: {
		UserReportStackChart
	}
}
</script>

<style lang="scss" scoped>
.chart-levels {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    margin-bottom: 20px;
    padding-top: 20px;
    border-top: 1px solid #dadada;

    .emotion-level, .stress-level {
        flex-shrink: 0;
        flex-grow: 1;
        display: flex;
        flex-direction: column;

        .chart canvas {
            height: 300px;
        }
    }

    .chart-title {
        margin-bottom: 10px;
        font-weight: 600;
        padding-left: 10px;
        font-size: 1em;
    }

    .emotion-level {
        width: 60%;
    }
}
</style>
